import { CategoryRestrictionsProfileConfiguration, ModelNameFlags } from '@era/settings-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';
import { Category } from '../router/category';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryRestrictionProfilePresetConfigurationResolverActions = createActionGroup({
  source: 'Restriction Profile Preset Configuration resolver',
  events: {
    'Category Restriction Profile Configuration requested': props<{
      category: Category;
      modelNames: ModelNameFlags[];
    }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryRestrictionProfilePresetConfigurationApiActions = createActionGroup({
  source: 'Restriction Profile Preset Configuration API',
  events: {
    'Restriction Profile Configuration loaded': props<{
      configurations: CategoryRestrictionsProfileConfiguration[];
    }>(),
    'Restriction Profile Configuration loaded failed': props<{ error: ErrorModel }>(),
    'Restriction Profile Configuration set': props<{
      category: Category;
      configurations: CategoryRestrictionsProfileConfiguration[];
    }>(),
    'Restriction Profile Configuration set failed': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryRestrictionProfilePresetConfigurationViewActions = createActionGroup({
  source: 'Restriction Profile Preset Configuration Category view',
  events: {
    'Restriction Profile Configuration selected': props<{
      category: Category;
      profiles: CategoryRestrictionsProfileConfiguration[];
    }>(),
  },
});
